module.exports = __webpack_public_path__ + "static/media/Raleway-Medium.d35a8875.ttf";